// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!lato-font/css/lato-font.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/icons/dragCross.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../assets/images/icons/dragCrossTenantLight.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../assets/images/icons/dragCrossDarkMode.svg");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../../assets/images/icons/dragCrossTenantDark.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
exports.push([module.id, ".defaultTheme div.react-grid-item.react-grid-placeholder{background-color:#cecece}.tenantTheme div.react-grid-item.react-grid-placeholder{background-color:#cecece}.defaultDarkTheme div.react-grid-item.react-grid-placeholder{background-color:#111}.tenantDarkTheme div.react-grid-item.react-grid-placeholder{background-color:#111}.subTenantTheme div.react-grid-item.react-grid-placeholder{background-color:#cecece}.subTenantDarkTheme div.react-grid-item.react-grid-placeholder{background-color:#111}.R6Do4oaALZYCQNru4XA38{margin-bottom:20px}._30RBAzofpSo6SMnkWPngT7{width:100%;display:flex;justify-content:space-between}.hPaOaOvkVAGYu4axIn92R{border:1px solid}.defaultTheme .hPaOaOvkVAGYu4axIn92R{background-color:#fff}.tenantTheme .hPaOaOvkVAGYu4axIn92R{background-color:#fff}.defaultDarkTheme .hPaOaOvkVAGYu4axIn92R{background-color:#222}.tenantDarkTheme .hPaOaOvkVAGYu4axIn92R{background-color:#333}.subTenantTheme .hPaOaOvkVAGYu4axIn92R{background-color:#fff}.subTenantDarkTheme .hPaOaOvkVAGYu4axIn92R{background-color:#333}.defaultTheme .hPaOaOvkVAGYu4axIn92R{border-color:#f0f0f0}.tenantTheme .hPaOaOvkVAGYu4axIn92R{border-color:#f0f0f0}.defaultDarkTheme .hPaOaOvkVAGYu4axIn92R{border-color:#111}.tenantDarkTheme .hPaOaOvkVAGYu4axIn92R{border-color:#111}.subTenantTheme .hPaOaOvkVAGYu4axIn92R{border-color:#f0f0f0}.subTenantDarkTheme .hPaOaOvkVAGYu4axIn92R{border-color:#111}._2h4-nr3WENaAOVbM1p2UUd{border-radius:3px;padding:40px;vertical-align:top;height:100%}.defaultTheme ._2h4-nr3WENaAOVbM1p2UUd{background-color:#fff}.tenantTheme ._2h4-nr3WENaAOVbM1p2UUd{background-color:#fff}.defaultDarkTheme ._2h4-nr3WENaAOVbM1p2UUd{background-color:#222}.tenantDarkTheme ._2h4-nr3WENaAOVbM1p2UUd{background-color:#333}.subTenantTheme ._2h4-nr3WENaAOVbM1p2UUd{background-color:#fff}.subTenantDarkTheme ._2h4-nr3WENaAOVbM1p2UUd{background-color:#333}._2C6-SdQ9bgBVdsiWE0YKt0{border-radius:3px;vertical-align:top;height:100%;padding:160px 0;text-align:center}.defaultTheme ._2C6-SdQ9bgBVdsiWE0YKt0{background-color:#f0f0f0}.tenantTheme ._2C6-SdQ9bgBVdsiWE0YKt0{background-color:#f0f0f0}.defaultDarkTheme ._2C6-SdQ9bgBVdsiWE0YKt0{background-color:#4c4c4c}.tenantDarkTheme ._2C6-SdQ9bgBVdsiWE0YKt0{background-color:#4c4c4c}.subTenantTheme ._2C6-SdQ9bgBVdsiWE0YKt0{background-color:#f0f0f0}.subTenantDarkTheme ._2C6-SdQ9bgBVdsiWE0YKt0{background-color:#4c4c4c}._3qoyzFkMiNU-2F1ki_c-k_{font-size:16px;font-weight:600;line-height:20px;border-bottom:1px solid;padding-bottom:4px;position:relative;padding-bottom:10px;display:flex;flex-direction:row;margin-bottom:20px}.defaultTheme ._3qoyzFkMiNU-2F1ki_c-k_{border-color:#f0f0f0}.tenantTheme ._3qoyzFkMiNU-2F1ki_c-k_{border-color:#f0f0f0}.defaultDarkTheme ._3qoyzFkMiNU-2F1ki_c-k_{border-color:#111}.tenantDarkTheme ._3qoyzFkMiNU-2F1ki_c-k_{border-color:#111}.subTenantTheme ._3qoyzFkMiNU-2F1ki_c-k_{border-color:#f0f0f0}.subTenantDarkTheme ._3qoyzFkMiNU-2F1ki_c-k_{border-color:#111}._3c904L5aCQBqhzpmmDOwk-{width:18px;height:18px;background-image:var(--path);margin-top:20px;margin-right:20px;cursor:grabbing}.defaultTheme ._3c904L5aCQBqhzpmmDOwk-{--path:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.tenantTheme ._3c904L5aCQBqhzpmmDOwk-{--path:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}.defaultDarkTheme ._3c904L5aCQBqhzpmmDOwk-{--path:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ")}.tenantDarkTheme ._3c904L5aCQBqhzpmmDOwk-{--path:url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ")}.subTenantTheme ._3c904L5aCQBqhzpmmDOwk-{--path:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.subTenantDarkTheme ._3c904L5aCQBqhzpmmDOwk-{--path:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ")}.vKyN1y8Cmr_YQhYy-not3{position:absolute;right:-28px;top:-32px}._3Ai2NIwKp-jBDTvutopSlw{position:absolute;right:0px;top:-14px}._3UPj783uzjT1z4_XLhvlc0{text-align:center}._1sXJC51drnoS_kOFgHqX1d{position:relative;bottom:2px;margin-left:5px;margin-bottom:-6px;margin-top:-1px;display:inline-block}.OH3eCArz-zx6tcBZ4egdn{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:90%}", ""]);
// Exports
exports.locals = {
	"breakpointSm": "580px",
	"breakpointMd": "768px",
	"breakpointLg": "992px",
	"breakpointXl": "1200px",
	"breakpointXxl": "1600px",
	"whiteColor": "#fff",
	"homeViewTierTypeLabelTextColor": "#cecece",
	"homeCurrentPlanRedColor": "#362f3f",
	"homeCurrentPlanBlueColor": "#1d2d36",
	"homeCurrentPlanYellowColor": "#3b3025",
	"homeCardTextColor": "#8e8e8e",
	"homeSupportBadgeTextColor": "#91b9f0",
	"homeSupportBadgeColor": "#282828",
	"homeCardVersionColor": "#8e8e8e",
	"homeCardBackgroundColor": "#282828",
	"homeCardBorderColor": "#303030",
	"homeCardNameColor": "#cecece",
	"homeIconsColor": "#91b9f0",
	"homeWireIconColor": "#403aac",
	"homeWireIconBackgroundColor": "#a8a3ff",
	"homeInfoBadgeColor": "#606060",
	"activeBackgroundColor": "#476c86",
	"activeForegroundColor": "#476c86",
	"primaryButtonBackgroundColor": "#476c86",
	"secondaryButtonForegroundColor": "#91b9f0",
	"bannerBackgroundColor": "rgba(71,108,134,.5)",
	"linkTextColor": "#5f96bc",
	"primaryButtonBackgroundHoverColor": "#5f96bc",
	"secondaryButtonBackgroundHoverColor": "#354057",
	"destructiveButtonBackgroundHoverColor": "#c12020",
	"destructiveButtonActiveBackgroundColor": "#db2828",
	"primaryButtonBackgroundActiveColor": "#222",
	"secondaryButtonBackgroundActiveColor": "#273044",
	"destructiveButtonBackgroundColor": "#a51313",
	"navigationButtonBackgroundActiveColor": "#2e384f",
	"chartNegativeColor": "#f09191",
	"chartPositiveColor": "#5fe3a1",
	"chartNeutralColor": "#cecece",
	"errorBackgroundColor": "#f46464",
	"errorBorderColor": "#f46464",
	"errorTextColor": "#f46464",
	"errorWrapperBackgroundColor": "#f2c5c5",
	"warningBackgroundColor": "#e47530",
	"warningBorderColor": "#e47530",
	"warningTextColor": "#e47530",
	"secondaryWarningBackgroundColor": "#ffc915",
	"secondaryWarningBorderColor": "#ffc915",
	"secondaryWarningTextColor": "#ffc915",
	"successBorderColor": "#5fe3a1",
	"successTextColor": "#5fe3a1",
	"pageBackgroundColor": "#222",
	"wrapperBackgroundColor": "#dfe4f2",
	"urlSectionBackgroundColor": "#dfe4f2",
	"wrapperBorderColor": "#a1b0d5",
	"modelBoxBackgroundColor": "#4c4c4c",
	"contentBackgroundColor": "#333",
	"secondaryButtonBackgroundColor": "#333",
	"textColor": "#fff",
	"textGreyColor": "#8e8e8e",
	"primaryButtonForegroundColor": "#fff",
	"bannerForegroundColor": "#4c4c4c",
	"chartOutlineColor": "#222",
	"modalOverlayColor": "rgba(34,34,34,.4)",
	"contentDividerColor": "#111",
	"contentBorderColor": "#111",
	"nestedContentBorderColor": "#cecece",
	"disabledButtonBackgroundColor": "#cecece",
	"disabledButtonForegroundColor": "#4c4c4c",
	"inputHintColor": "#cecece",
	"inputBackgroundColor": "#4c4c4c",
	"hoverBackgroundColor": "#111",
	"toggleCheckedBackgroundColor": "#91b9f0",
	"toggleUncheckedBackgroundColor": "#cecece",
	"toggleForegroundColor": "#fff",
	"mapForegroundColor": "#f0f0f0",
	"mapBackgroundColor": "#222",
	"emptyStateEllipseBackgroundColor": "#494949",
	"emptyStateBiggestCircleBackgroundColor": "#484848",
	"emptyStateSmallestCircleBackgroundColor": "#4b4b4b",
	"emptyStatePersonColor": "#4a4a52",
	"emptyStatePersonShirtColor": "#91b9f0",
	"emptyStatePersonSleeveColor": "#3b5dab",
	"emptyStateEllipseBackgroundOpacity": ".599",
	"emptyStateBiggestCircleBackgroundOpacity": ".197",
	"emptyStateSmallestCircleBackgroundOpacityFirst": ".401",
	"emptyStateSmallestCircleBackgroundOpacitySecond": ".602",
	"emptyStateSmallestCircleBackgroundOpacityThird": ".846",
	"chartFirstSet": "#708add",
	"chartSecondSet": "#dd75a0",
	"chartThirdSet": "#4a7ab6",
	"chartForthSet": "#5f96bc",
	"chartFifthSet": "#c4874a",
	"chartSixthSet": "#b63e5c",
	"chartSeventhSet": "#6c8fa9",
	"chartEighthSet": "#f3a14e",
	"chartNinthSet": "#88bbdb",
	"chartTenthSet": "#e2afc3",
	"chartEleventhSet": "#b1bfde",
	"chartTwelfthSet": "#facf96",
	"optional": "#fff",
	"disabledTextColor": "#4c4c4c",
	"colorPickerBlack": "#000",
	"iconFillColor": "#91b9f0",
	"sortIconRegularColor": "#cecece",
	"sortIconHoverColor": "#5f96bc",
	"sortIconActiveColor": "#fff",
	"calendarRangeBackgroundColor": "#91b9f0",
	"selectedTabColor": "#91b9f0",
	"basicTierBannerColor": "rgba(188,132,74,.0980392157)",
	"basicTierBannerBorderColor": "#9d6f3f",
	"premiumTierBannerColor": "rgba(107,149,184,.0980392157)",
	"premiumTierBannerBorderColor": "#6b95b8",
	"diamondTierBannerColor": "rgba(181,78,119,.0980392157)",
	"diamondTierBannerBorderColor": "#b54e77",
	"starTierBannerBorderColor": "#6f53e0",
	"chartSuccessColor": "#009e57",
	"chartFailColor": "#db3737",
	"notVerified": "#708add",
	"textFieldColor": "#111",
	"focusOutlineColorInput": "#3b5dab",
	"focusOutlineColorButton": "#d661e5",
	"tooltipTextColor": "#4c4c4c",
	"tooltipBackgroundColor": "#f0f0f0",
	"chipBackgroundColor": "#4c4c4c",
	"chipContentColor": "#fff",
	"chipUserIconColor": "#111",
	"successIconColor": "#5fe3a1",
	"errorIconColor": "#f09191",
	"localBannerBackgroundColor": "#33405f",
	"localBannerBorderColor": "#2d2d2d",
	"errorBannerBackgroundColor": "#f1a9a9",
	"localBannerTextColor": "#fff",
	"successBadgeBackgroundColor": "#006f1f",
	"successBadgeTextColor": "#e5f2e9",
	"warningBadgeBackgroundColor": "#ffda5c",
	"warningBadgeTextColor": "#715907",
	"errorBadgeBackgroundColor": "#9c2a2a",
	"errorBadgeTextColor": "#fff",
	"infoBadgeBackgroundColor": "#374f86",
	"infoBadgeTextColor": "#fff",
	"infoIconBackgroundColor": "#f0f0f0",
	"neutralBadgeBackgroundColor": "#606060",
	"neutralBadgeTextColor": "#fff",
	"strokeColor": "#364c7d",
	"textHighlightForegroundColor": "linear-gradient(0deg, rgba(255, 201, 21, 0.3) 0%, rgba(255, 201, 21, 0.3) 100%)",
	"textHighlightBackgroundColor": "#fff",
	"skeletonLoaderBackgroundColor": "#222",
	"firstLevelTierBackgroundColor": "#fff6ee",
	"secondLevelTierBackgroundColor": "#f2faff",
	"thirdLevelTierBackgroundColor": "#fff8fb",
	"fourthLevelTierBackgroundColor": "#6f53e0",
	"defaultStarColor": "#007b22",
	"userDefaultStarColor": "#cecece",
	"addOnsCheckmarkColor": "#5fe3a1",
	"warningBannerBackgroundColor": "#ffd95b",
	"warningBannerBorderColor": "#fff1c1",
	"warningBannerTextColor": "#111",
	"warningIconBackgroundColor": "#111",
	"warningIconExclamationColor": "#ffc915",
	"hoverColor": "rgba(71,108,134,.3)",
	"navigationButtonBackgroundHoverColor": "#2b303c",
	"conditionToggleButtonBackgroundColor": "#222",
	"conditionToggleButtonBorderColor": "#4c4c4c",
	"conditionTableBackgroundColor": "#222",
	"conditionTableBorderColor": "#4c4c4c",
	"conditionTableNestedBackgroundColor": "#111",
	"tabHoverColor": "#4c4c4c",
	"modularPurpleColor": "#b9a8ff",
	"modularBackgroundPurpleColor": "#41366e",
	"readyToUseSkyBlueColor": "#72bcf8",
	"readyToUseBackgroundBlueColor": "#1b364c",
	"readyToUseBorderBlueColor": "#0c62a8",
	"modularBorderPurpleColor": "#53429c",
	"descriptionTextColor": "#8e8e8e",
	"lightGreenBackgroundColor": "#e5f2e9",
	"lightBlueBackgroundColor": "#e0e5f3",
	"errorBannerColor": "#f1a9a9",
	"errorBannerTextColor": "#4c4c4c",
	"bannerIconBackgroundColor": "#db2828",
	"bannerIconColor": "#fff",
	"accordianSuccessBackgroundColor": "#183d22",
	"accordianSuccessBorderColor": "#096422",
	"accordianSuccessTextColor": "#5fe3a1",
	"homeCurrentPlanLabelTextColor": "#606060",
	"cardBorderColor": "#4c4c4c",
	"hoverCardBorderColor": "#8e8e8e",
	"defaultTheme": "defaultTheme",
	"tenantTheme": "tenantTheme",
	"defaultDarkTheme": "defaultDarkTheme",
	"tenantDarkTheme": "tenantDarkTheme",
	"subTenantTheme": "subTenantTheme",
	"subTenantDarkTheme": "subTenantDarkTheme",
	"dashboardViewDescription": "R6Do4oaALZYCQNru4XA38",
	"dashboardViewContainer": "_30RBAzofpSo6SMnkWPngT7",
	"cardContainer": "hPaOaOvkVAGYu4axIn92R",
	"card": "_2h4-nr3WENaAOVbM1p2UUd",
	"cardCreateChart": "_2C6-SdQ9bgBVdsiWE0YKt0",
	"cardHeader": "_3qoyzFkMiNU-2F1ki_c-k_",
	"cardMenuButton": "_3c904L5aCQBqhzpmmDOwk-",
	"dropdown": "vKyN1y8Cmr_YQhYy-not3",
	"widgetActions": "_3Ai2NIwKp-jBDTvutopSlw",
	"failureMessage": "_3UPj783uzjT1z4_XLhvlc0",
	"info": "_1sXJC51drnoS_kOFgHqX1d",
	"cardTitle": "OH3eCArz-zx6tcBZ4egdn"
};
module.exports = exports;
